
export enum WhatIfDownloadFileTypeCd {
	SHIPMENT_FILE = 'ShipmentFile',
	WHAT_IF_RATING_RESULT_FILE = 'WhatIfRatingResultFile'}
